import { IconComponent } from './types';

const RulerIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <rect
      width={14}
      height={5}
      x={14.049}
      y={4.191}
      stroke="currentColor"
      rx={0.5}
      transform="rotate(134.175 14.05 4.191)"
    />
    <path
      stroke="currentColor"
      d="M10.883 5.298 8.552 3.033M8.772 6.035 6.62 3.945M8.095 8.166 5.764 5.902M5.984 8.904 3.833 6.813M5.308 11.035 2.977 8.771"
    />
  </svg>
);
export default RulerIcon;
